import React, { Suspense } from "react";
import { ModalPattern, Regular } from "@worthy-npm/clarity";

import {
    isMobile,
    MIN_SIMILAR_ITEMS_TO_SHOW,
} from "../../../helpers/ApplicationHelper";

import LoaderSuspense from "../../loaderSuspense";
import LightListing from "./../lightListing";
import UserActions from "lib/userActions";
import I18n from "lib/i18n/i18n";
import GA from "../../../lib/ga";

const Stages = React.lazy(() => import("../../listing/stages"));
const FAQ = React.lazy(() => import("../../listing/listingFAQ"));
const SimilarItemsContainer = React.lazy(() =>
    import("../../similarItemsContainer")
);
function convertNewLinesToBreaks(text) {
    return text.split("\n").map((item, index) => (
        <React.Fragment key={index}>
            {item}
            <br />
        </React.Fragment>
    ));
}
class ExtraInfoMobileSlider extends React.Component {
    constructor(props) {
        super(props);
        this.isMobile = isMobile();
        this.state = {
            slide: props.openSlide || "",
        };
        this.slides = ExtraInfoMobileSlider.getSlides();
    }

    static getSlide = ({ state, props }) => {
        let { slide } = state;
        const { item, version } = props;

        if (typeof slide === "string") {
            slide = ExtraInfoMobileSlider.getSlides().find(
                (s) => s.slug === slide
            );
        }

        let title = slide["caption"];
        let content;

        switch (slide["slug"]) {
            case "photos":
            case "shipping":
            case "auth":
            case "grading":
            case "auction":
            case "payment":
            case "cleaning":
                content = (
                    <div className="extra-info-slider-description">
                        {convertNewLinesToBreaks(slide["description"])}
                    </div>
                );
                break;
            case "faq":
                content = (
                    <Suspense fallback={<LoaderSuspense />}>
                        <FAQ
                            item={item}
                            parent={LightListing}
                            needsTitle={false}
                            userActionsCb={UserActions.lightListingPage}
                        />
                    </Suspense>
                );
                break;
            case "deals":
                content = (
                    <Suspense fallback={<LoaderSuspense />}>
                        <SimilarItemsContainer
                            items={item["similar_items"]}
                            goTo={LightListing.goTo}
                            item={item}
                            isSimplified={true}
                            userActionsCb={UserActions.lightListingPage}
                            version={version}
                        />
                    </Suspense>
                );
                break;
            case "process":
                content = (
                    <Suspense fallback={<LoaderSuspense />}>
                        <div className="">
                            <Stages
                                simple={true}
                                step={1}
                                item={item}
                                version={0}
                                showBannerCb={() => {}}
                            />
                        </div>
                    </Suspense>
                );
                break;
        }
        return { title, content };
    };

    static getSlides = () => {
        return I18n.getVar("listingPageLight::additionalInfo::list");
    };

    renderModal = () => {
        const { title, content } = ExtraInfoMobileSlider.getSlide({
            state: this.state,
            props: this.props,
        });

        return (
            <ModalPattern
                title={title}
                textAlign={"center"}
                closeOnClickOutside={true}
                onClose={() => {
                    this.props.closeSlide();
                }}
                closeOnEscape={false}
                isWide={true}
                closeIcon={true}
            >
                <div className="extra-info-modal text-left">{content}</div>
            </ModalPattern>
        );
    };

    openModal = (slide) => {
        this.props.openSlideViaParent(slide["slug"]);
        // Made this way because other boxes can open popups check `componentDidUpdate`
    };

    logAction = (message) => {
        this.props.logAction(message, this.props.item.id, this.props.version);
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.openSlide !== prevProps.openSlide) {
            this.setState({
                slide: this.slides.find((s) => s.slug === this.props.openSlide),
            });
        }
    }

    render() {
        const { item } = this.props;
        const { slide } = this.state;
        return (
            <div className="extra-info-wrapper">
                <ul
                    className={`extra-info-slides ${
                        item["similar_items"] && item["similar_items"].length
                            ? " with-similar-items "
                            : ""
                    }`}
                    onTouchEndCapture={() => {
                        this.logAction(
                            `"Want to learn more" slider has been clicked/touched`
                        );
                    }}
                >
                    {this.slides.map((slide, key) => {
                        if (
                            slide["slug"] === "deals" &&
                            (!item["similar_items"] ||
                                item["similar_items"].length <
                                    MIN_SIMILAR_ITEMS_TO_SHOW)
                        ) {
                            return null;
                        }
                        return (
                            <li
                                key={"extra-slide" + key}
                                className={`extra-slide extra-slide_${slide["slug"]}`}
                                onClick={() => {
                                    GA.lightListingLearnMore({
                                        title: slide["slug"],
                                    });
                                    this.logAction(
                                        `«${slide["caption"]}» has been clicked`
                                    );
                                    this.openModal(slide);
                                }}
                            >
                                <span className={"extra-slide-caption"}>
                                    {slide["caption"]}
                                </span>
                            </li>
                        );
                    })}
                </ul>
                {slide ? this.renderModal() : null}
            </div>
        );
    }
}

export default ExtraInfoMobileSlider;
